
export default {
  currentCompany: state => state.currentCompany,
  isCallingCompany: state => state.isCallingCompany,
  /* Office Feature getters */
  currentCompanyFeatures: state => state.currentCompany && state.currentCompany.activatedFeatures ? state.currentCompany.activatedFeatures : [],
  currentCompanyHasMerchantFeature: (state) => {
    if (state.currentCompany && state.currentCompany.id) {
      const merchantFeature = state.currentCompany.activatedFeatures.find(el => el.feature.code === 'MERCHANT_FEATURE')
      return !!merchantFeature
    }
    return false
  },
  hasOfficeOwnerInviteFeature: state => {
    return state.currentCompany?.activatedFeatures?.findIndex(el => el.feature.code === 'OWNER_INVITE_USER') >= 0
  },
  currentCompanyConfigs: state => state.currentCompany && state.currentCompany.configs && state.currentCompany.configs.length > 0 ? state.currentCompany.configs : [],
  /*  Office Form Configurations */
  officeFormConfigurations: state => state.officeFormConfigurations

}
